export const apiUrl = process.env.REACT_APP_API_URL;
export const serviceCoach = process.env.REACT_APP_API_URL_SERVICE_COACH;
export const serviceFood = process.env.REACT_APP_API_URL_SERVICE_FOOD;
export const idClarityProd = process.env.REACT_APP_API_URL_CLARITY_PROD;
export const idClarityStg = process.env.REACT_APP_API_URL_CLARITY_STG;
export const idClarityQa = process.env.REACT_APP_API_URL_CLARITY_QA;
export const idClarityDev = process.env.REACT_APP_API_URL_CLARITY_DEV;


